import { Inject, Injectable } from '@angular/core';
import { ApiServices, SharedApiExecutorService } from '@ddv/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
    private readonly subjects: Record<string, Subject<boolean>> = {};

    constructor(@Inject(ApiServices.flags) private readonly api: SharedApiExecutorService) {}

    isFlagEnabled(name: string, clientCode: string): Observable<boolean> {
        if (!this.subjects[name]) {
            this.subjects[name] = new ReplaySubject(1);
            this.callApi(name, clientCode);
        }

        return this.subjects[name].asObservable();
    }

    private callApi(name: string, clientCode: string): void {
        this.api.invokeServiceWithParams<{ enabled: boolean }>(`/user/${name}/${clientCode}`)
            .subscribe({
                next: (response) => this.subjects[name].next(response.enabled),
            });
    }
}
